import Vue from "vue";
import { mapGetters } from "vuex";

import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { LoadingSpinner, StaticFormControl } from "@/components";
import { formatDateTime, stringHelper } from "@/components/mixins";
import { EventTrackingService, ShoppingCartService } from "@/services";
import { IFullPartDetailWithStatusDto } from "@/types";

import { default as AddPartToList } from "@/components/PartDetail/Dialogs/AddPartToList/AddPartToList.vue";

export default Vue.extend({
    name: "AddToCart",

    components: {
        FontAwesomeIcon,
        LoadingSpinner,
        StaticFormControl,
        AddPartToList,
    },
    mixins: [formatDateTime, stringHelper],
    computed: {
        ...mapGetters(["activeAccountId", "billingCurrencyCode", "cartSummary", "getContentItem", "user","canPlaceOrders"]),
        quantityInCart(){
            if (!this.canPlaceOrders){
                return;
            }
            var partInCart = this.cartSummary.Parts.filter((x: any) => x.PartId === this.details.Id);
            if(partInCart && partInCart.length > 0)
            {
                return partInCart[0].Count;
            }
            return 0
        }
    },

    props: {
        details: {
            type: Object,
            required: true,
        },
        addToPartList: Function,
    },

    data: () => ({
        plusIcon: faPlus,
        listIcon: faList,
        quantity: 1,
        numberInCart: 0,
        addingToCart: false
    }),

    created() {
        const { OemPartCode } = this.details as IFullPartDetailWithStatusDto;

        EventTrackingService.trackEvent({
            action: "Viewed Part Status",
            category: "Orderable",
            label: OemPartCode,
            value: 1,
        });
        
        this.setMinimumQuanity();
    },

    methods: {
        async submitAddToCart() {
            this.addingToCart = true;
            const { Id, OemPartCode } = this.details as IFullPartDetailWithStatusDto;

            var params = {
                shoppingCartId: this.cartSummary.Id,
                partId: Id,
                quantity: this.quantity,
                accountId: this.activeAccountId,
                userId: this.user.UserId
              }

            ShoppingCartService.AddShoppingCartItem(params).then(addResult => {
                    this.$store.dispatch("LOAD_CART_SUMMARY", {accountId: this.activeAccountId, userId: this.user.UserId})
                }).catch(err => {
                    this.$store.commit("pushMessage", {
                        header: "",
                        message: "Error occurred adding part to cart",
                        IsError: true
                      })
                })
                .finally(() =>{
                    this.addingToCart = false
                });

            EventTrackingService.trackEvent({
                category: "ShoppingCart-AddItem",
                action: "From Part Detail",
                label: OemPartCode,
                value: this.quantity,
            });

            this.setMinimumQuanity();
        },

        addToCartDidClick() {
            this.addToPartList();
        },

        setMinimumQuanity() {
            const { MinimumOrderQuantity } = this.details as IFullPartDetailWithStatusDto;

            if (MinimumOrderQuantity) {
                const remainingMinimum = MinimumOrderQuantity - this.numberInCart;
                this.quantity = remainingMinimum > 1 ? remainingMinimum : 1;
            } else {
                this.quantity = 1;
            }
        },
        setQuantity(quantity: number){
            this.quantity = quantity;
        }
    },
});
